<template>
  <v-tooltip top color="primary">
    <template v-slot:activator="{ on }">
      <v-chip v-on="on" small color="success" text-color="white">
        <v-avatar>
          <v-icon>check_circle</v-icon>
        </v-avatar>
        {{ $t("screener.reserved.title") }}
      </v-chip>
    </template>
    <span class="background--text body-1">{{
      $t("screener.reserved.tooltip")
    }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ReservedIndicator"
};
</script>

<style>
</style>
